module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAUCAYAAADhj08IAAAAAXNSR0IArs4c6QAAAM9JREFUSA3tlLEJAkEQRW97EA0ERRFFTCxAsBh7sAFbMDCyChNbMRDFQw3sYX0LM/E6yazBHnw+uzfDf/xgm8bhizF20QUtHOJsEUDt0BvNbZsO0wL3wmcOcbYIgXviU9umw7TAtfjEIc4WIXAPfGzbdJgWuDs+coizRQjcDR/aNh2mBe6KDzQucFhx6OhFQd+S3UPrEEKbwM4c+gWBNDpBpYI2gB31sqhTzhJ90AGFojAaXqG0iZzXpnIN6f/alDaR879sKkEDdkJ79NM79QWTSN+it4levgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/left.png
// module id = EnDv
// module chunks = 1